<header class="header">
  <div class="header-left">
    <img src="assets/logo.png" alt="Logo" class="logo">
  </div>
  
  <nav class="header-nav" [class.open]="isMenuOpen">
    <ng-container *ngFor="let item of topLevelNavItems">
      <a
        *ngIf="shouldShowMenuItem(item)"
        [routerLink]="item.route"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
        class="nav-link"
      >{{ item.label }}</a>
    </ng-container>
  </nav>
  <div class="header-right">
    <a href="https://play.google.com/store/apps/details?id=org.unfpa.mhsp.tuneme" target="_blank" class="download-btn">Download</a>
    <div class="user-profile">
      <span>Country</span>
      <select class="country-dropdown" [(ngModel)]="selectedCountry" (change)="onCountryChange()">
        <option *ngFor="let country of countries" [ngValue]="country">{{ country.name }}</option>
      </select>
    </div>
  </div>
</header>